import {mixpanel} from "../util/mixpanel";


export function updateVisitsAndShowModal() {
    // update visits
    const visitCount = localStorage.getItem('visit_count') || 0;
    const hasRated = localStorage.getItem('has_rated') === "true";
    localStorage.setItem('visit_count', parseInt(visitCount) + 1);

    if (parseInt(visitCount) >= 10 && !hasRated) {
        setTimeout(function () {
            mixpanel.track('Rating', {"visit_count": visitCount});
            const ratingModal = document.getElementById('rating_modal');
            ratingModal.classList.remove("hidden");
        }, 30000);  // 30 seconds
    }
}

document.getElementById('rate_now_btn').addEventListener('click', function() {
    localStorage.setItem('has_rated', 'true')
});

document.getElementById('rate_later_btn')?.addEventListener('click', function() {
    localStorage.setItem('visit_count', "1");
    const ratingModal = document.getElementById('rating_modal');
    ratingModal.classList.add("hidden");
});

